<dx-button
  [hint]="'COMMON.E-SIGNATURE' | translate"
  type="default"
  stylingMode="text"
  class="signature"
  (onClick)="show()"
>
  <i #iconRef class="fa-solid fa-file-signature signature-icon"></i>
</dx-button>
<dx-popover
  [target]="iconRef"
  [visible]="showModal"
  (onHiding)="close()"
>
  <div class="signature-preview">
    <img [src]="eSignatureImageUrl" alt="Signature" />
  </div>
</dx-popover>